import styles from './Leaderboard.module.scss'
import { LeaderboardProps } from '~types'
import Image from 'next/image'
import Slider from 'react-slick'
import { Heading } from '~elements'
import { useWindowSize } from 'utils/hooks'
import { useRef, useState } from 'react'
import { NEXT_IMAGE_QUALITY } from '~constants'

const Leaderboard = ({ report }: { report: Array<LeaderboardProps> }) => {
  const { isBreakpoint: isBelowBreakpointMobile } = useWindowSize('sm', '<')

  const sliderRef = useRef<Slider | null>(null)
  const sliderSettings = {
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand' as const,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0
  }

  const ImageComponent = (props: { src: string }) => {
    const { src } = props || {}
    return src ? (
      <Image
        src={src}
        alt={'Leaderboard Video thumbnail'}
        sizes='100vw'
        width={0}
        height={0}
        style={{ width: '100%', height: '100%' }}
        quality={NEXT_IMAGE_QUALITY}
      />
    ) : null
  }

  return (
    <div className={styles['leaderboard-container']}>
      <Heading level={2} noMarginBottom noMarginTop>Daily Leaderboard</Heading>
      {isBelowBreakpointMobile ? (
        <Slider ref={sliderRef} {...sliderSettings}>
          {report.map((item, index) => (
            <div className={styles['thumbnail-container']} key={item._id + index}>
              <div className={`${styles['thumbnail-image-container']} ${styles[`count-${index + 1}-border`]}`}>
                <ImageComponent src={item?.posterImage} />
                <div className={`${styles['count']} ${styles[`count-${index + 1}`]}`}>{index + 1}</div>
              </div>
              <div className={styles['details-container']}>
                <Heading level={3} levelDisplay={3}>
                  {item?.firstName} {item?.lastName}
                </Heading>
                <div>
                  <p>{item?.schoolName}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      ) : (
        <div className={styles['leaderboard-thumbnail-container']}>
          {report.map((item, index) => (
            <div key={`container-${item._id}-${index}`} className={styles['thumbnail-container']}>
              <div className={`${styles['thumbnail-image-container']} ${styles[`count-${index + 1}-border`]}`}>
                <ImageComponent src={item?.posterImage} />
                <div className={`${styles['count']} ${styles[`count-${index + 1}`]}`}>{index + 1}</div>
              </div>
              <div className={styles['details-container']}>
                <Heading level={3} levelDisplay={3}>
                  {item?.firstName} {item?.lastName}
                </Heading>
                <Heading level={5} levelDisplay={5}>
                  {item?.schoolName}
                </Heading>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default Leaderboard
